module.exports = __webpack_public_path__ + "uk.7e840c26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/flags/uk.png
// module id = 1492
// module chunks = 0